import React, { useState } from "react";
import QuestionComponent from "./QuestionComponent";
import Modal from "react-modal";
import "./QuestionsList.css";
import { VscIssueReopened } from "react-icons/vsc";
import AddQuestionComponent from "./AddQuestionComponent";

const QuestionsList = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  return (
    <div className="questions-list-body">
      <div className="quizzes-list-buttons">
        <button
          style={{
            background: "none",
            border: "none",
            marginRight: "30px",
            cursor: "pointer",
          }}
          onClick={() => window.location.reload()}
        >
          <VscIssueReopened size={20} color="gray" />
        </button>
        <button
          onClick={() => setModalIsOpen(true)}
          className="add-question-cta"
        >
          Add question
        </button>
      </div>
      <Modal
        closeTimeoutMS={200}
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
          },
          content: {
            position: "absolute",

            width: "30%",
            height: "70%",

            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "15px",
            outline: "none",
            padding: "35px",
            paddingLeft: "45px",

            border: "0",
            bottom: "auto",
            minHeight: "10rem",
            left: "50%",
            position: "fixed",
            right: "auto",
            top: "50%",
            transform: "translate(-50%,-50%)",
            minWidth: "20rem",
            maxWidth: "60rem",
          },
        }}
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
      >
        {<AddQuestionComponent setModalIsOpen={setModalIsOpen} />}
      </Modal>

      <div className="ql-titles">
        <div className="ql-question">Question</div>
        <div className="ql-text">Text</div>
        <div className="ql-options">Options</div>
        <div className="ql-correct-option">Correct option</div>
        <div className="ql-interviewer-name">Interviewer Name</div>
        <div className="ql-interview-title">Interviewer Title</div>
        <div className="ql-asset-url">Asset URL</div>
        <div className="ql-explanation-asset-url">Expln. Asset URL</div>
      </div>
      <div className="questions-list">
        {props.questions.map((question) => (
          <QuestionComponent
            key={question.question}
            question={question.question}
            correctOption={question.correctOption}
            options={question.options}
            text={question.text}
            interviewerName={question.interviewerName}
            interviewerTitle={question.interviewerTitle}
            assetUrl={question.assetURL}
            explanationAssetUrl={question.explanationAssetURL}
          />
        ))}
      </div>
    </div>
  );
};

export default QuestionsList;
